import { render, staticRenderFns } from "./RegisterCommission.vue?vue&type=template&id=71739e06"
import script from "./RegisterCommission.vue?vue&type=script&lang=js"
export * from "./RegisterCommission.vue?vue&type=script&lang=js"
import style0 from "./RegisterCommission.vue?vue&type=style&index=0&id=71739e06&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports